<template>
	<div
		class="header-sponsors js-header-sponsors"
		:class="{ 'alternative-header-is-active': alternativeHeaderActive }"
	>
		<div :class="{ 'l-container': alternativeHeaderActive }">
			<div class="header-sponsors__inner">
				<component
					:is="sponsor.translatedLink ? 'a' : 'div'"
					v-for="(sponsor, i) in internalSponsors"
					:key="i"
					:href="sponsor.translatedLink ? sponsor.translatedLink : null"
					target="_blank"
					class="header-sponsors__sponsor"
				>
					<img
						class="header-sponsors__img"
						:class="[!$arenaConfig.headerSponsorsColored ? '-grayscale' : '']"
						:src="$Helpers.getScaledImageUrl(sponsor.imageUrl, 160)"
					>
					<div
						v-if="hasAtLeastOneTitle"
						class="header-sponsors__title"
					>
						{{ sponsor.translatedTitle ? sponsor.translatedTitle : '&nbsp;' }}
					</div>
				</component>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name:  'HeaderSponsors',
	props: {
		sponsors: {
			type:    Array,
			default: () => [],
		},
		alternativeHeaderActive: {
			type:    Boolean,
			default: false,
		},
	},
	computed: {
		internalSponsors() {
			return this.sponsors.map((sponsor) => {
				if (typeof sponsor === 'string') {
					return {
						imageUrl: sponsor,
					};
				}

				return sponsor;
			});
		},
		hasAtLeastOneTitle() {
			return this.internalSponsors.some(sponsor => sponsor.translatedTitle);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.header-sponsors {
	background-color: var(--color-grey-100);
	margin-top: -5px; // adjust for white gap caused by aspect-ratio on header

	body.-t-light & { // stylelint-disable-line selector-no-qualifying-type
		background-color: var(--color-grey-950);
	}

	&.alternative-header-is-active {
		margin-bottom: $sp5;
		margin-top: -#{$sp6};

		@include size(sm-up) {
			background-color: transparent !important; // stylelint-disable-line declaration-no-important
		}

	}
}

.header-sponsors__inner {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	padding: $sp4 $sp2;
	gap: $sp3-5;

	.header-sponsors.alternative-header-is-active & {
		border-radius: 0 0 var(--t-border-radius-card--lg) var(--t-border-radius-card--lg);
		background-color: var(--color-grey-100);

		body.-t-light & { // stylelint-disable-line selector-no-qualifying-type
			background-color: var(--color-grey-950);
		}
	}

	@include size(sm-up) {
		padding: $sp4 $sp3;
		gap: $sp5;
	}

	@include size(md-up) {
		gap: $sp6;
	}

	@include size(lg-up) {
		padding: $sp5 $sp3;
		gap: $sp7-5;
	}
}

.header-sponsors__sponsor {
	display: flex;
	gap: $sp2;
	flex-direction: column;
	align-items: flex-start;
	width: calc(100vw / 4);

	&:not(:last-child) {
		margin-right: $sp3-5;

		@include size(sm-up) {
			margin-right: $sp4;
		}

		@include size(md-up) {
			margin-right: $sp6;
		}

		@include size(lg-up) {
			margin-right: $sp7-5;
		}

		@supports (gap: 1rem) {
			margin-right: 0 !important; // stylelint-disable-line declaration-no-important
		}
	}

	@include size(sm-up) {
		width: calc(100vw / 7);
	}

	@include size(md-up) {
		width: calc(100vw / 9);
	}

	@include size(lg-up) {
		width: calc((100vw - (100vw - #{$grid-container-width})) / 9);
	}
}

.header-sponsors__img {
	width: 100%;
	max-height: 40px;
	object-fit: contain;

	&.-grayscale {
		filter: grayscale(1);
		mix-blend-mode: darken;
	}

	@include size(lg-up) {
		max-height: 70px;
	}
}

.header-sponsors__title {
	@include font-size(fs-60);
	white-space: nowrap;
}
</style>
